import { orderBy } from 'lodash';
import { GLOBAL_DISPLAY_FORMAT } from '~/config/formatters';
import type { AppThunk } from '~/@types/app-types';
import { notifySuccess } from '~/common/notifications';
import {
    selectDeals,
    selectDealsResponse,
    selectNewDeal,
    selectNewSong,
    getUserProfileData,
    selectUserData,
    getContactTypeList,
} from '~/features/dashboard/store/selectors';
import { NewUser } from '~/store/user/models';
import {
    createContactActions,
    createNewDealStageActions,
    createNewSongStageActions,
    getContactsActions,
    getContractsActions,
    getDealDetailsActions,
    getDealsActions,
    getMusicsActions,
    newDealFormNextStep,
    newSongFormNextStep,
    resetNewDealForm,
    editNewDealForm,
    resetNewSongForm,
    getDealTypesList,
    getDealFormatsList,
    getDealCodesList,
    getContactTypesList,
    getSongSummaryDealActions,
    getDealSummaryActions,
    getSongDealsSummaryActions,
    getDealSongsSummaryActions,
    getSearchDealFilterActions,
    getDealSubDealsSummaryActions,
    getDealDocumentsActions,
    getDealDocumentTypesActions,
    getDealRegionsList,
    getUserProfileTypes,
    getSongListingsList,
    updateDefaultActions, getAKAsListingsList, getArtworkListingsList, getSoundListingsList,
} from './actions';
import { Deal } from './models';
import { CreatorApi } from '~/api/creator.api';
import { fakeContactData, fakeUserData } from '~/mock/fakeUser';
import { getAddressString } from '~/utils/helpers';
import { DealApi } from '~/api/deal.api';
import { fakeDeal } from '~/mock/fakeDeal';
import moment from 'moment';
import { MusicApi } from '~/api/music.api';
import { ContractApi } from '~/api/contract.api';
import { errorHandler } from '~/store/utils/errorHendler';
import { NewDealStepFourData, NewDealStepOneData, NewDealStepSixData } from '~/models/deals/new-deal/NewDealRequest.dto';
import { INewDealStepFourFormInputs, INewDealStepOneFormInputs, StepSixFormData, StepSevenFormData } from '~/models/deals/new-deal/formInputs';
import { push } from 'connected-react-router';
import { NewDealResponseDto } from '~/models/deals/new-deal/NewDealResponse.dto';
import { AccountingTerm } from '~/models/deals/new-deal/helpers';
import {
    INewQuickSongForm,
    INewQuickSongFormInputs,
    // INewSongStepFiveFormInputs,
    INewSongStepFourFormInputs,
    INewSongStepOneFormInputs,
    INewSongStepSixFormInputs,
    INewSongStepThreeFormInputs,
    INewSongStepTwoFormInputs,
} from '~/models/music/new-song/formInputs';
import { NewQuickSongEntryData, NewSongStepOneData } from '~/models/music/new-song/newSongRequests.dto';
import { axiosInstance } from '~/api/config/axios.config';
import { ProfileApi } from '~/api/profile.api';
import { UserProfile } from '~/models/profile/UserProfile.dto';
import {SongProjectTrack, songsDataTags} from '~/models/music/new-song/newSongResponse.dto';

export const createNewDealStepOneThunk: AppThunk<INewDealStepOneFormInputs & {
    creatorId: number;
    isDirty: boolean;
    contractSubTypeList?: NewDealResponseDto['contractSubTypeList'],
    contractType?: string;
}> = formData => async (
    dispatch,
    getState
) => {
    try {
        if (formData.isDirty) {
            dispatch(createNewDealStageActions.request());
            const additionalFields = {
                ...(formData.contractSubTypeList ? { contractSubTypeList: formData.contractSubTypeList } : {}),
                ...(formData.contractType ? { contractType: formData.contractType } : {}),
            }
            const stepOneData: NewDealStepOneData = {
                contractTitle: formData.dealName, projectId: formData.creatorId, step: 1,
                ...additionalFields,
            };
            const newDealState = selectNewDeal(getState());

            const requestData = newDealState?.contractRefNum ? { ...newDealState, ...stepOneData } : stepOneData;
            // console.log(requestData, 'requestData', stepOneData, 'newDealState', newDealState);
            const { data } = await DealApi.createNewDeal(requestData);
            dispatch(createNewDealStageActions.success(data));
            dispatch(getDealsThunk({ creatorId: requestData.projectId }));
        }
        dispatch(newDealFormNextStep());
    } catch (e) {
        dispatch(createNewDealStageActions.failure({ error: e }));
        return errorHandler('Deal Title already exists. Please create a new one', dispatch);
    }
};

export const createNewDealStepTwoThunk: AppThunk<any & { isDirty: boolean }> = formData => async (dispatch, getState) => {
    try {
        formData.isDirty = false;
        if (!formData.isDirty) {
            dispatch(createNewDealStageActions.request());
            const newDealState = selectNewDeal(getState());
            //console.log(formData.dataoptions, 'data options');
            let contractSubTypeListArray: any = [];
            //console.log(formData, 'request data');
            if (String(formData.dealType) === String(50)) {
                Object.keys(formData).map((item: any) => {
                    if (formData[`${item}`] === true && item !== 'isDirty') {
                        let obj = {
                            accStatusUseId: formData.dealType,
                            accStatusExtUseId: item,
                            freeText: formData.freeText ? formData.freeText : '',
                            // freeText: formData[`freeText${formData.dealType}`] ? formData[`freeText${formData.dealType}`] : '',
                        };
                        contractSubTypeListArray.push(obj);
                    }
                    return item;
                });
            } else {
                let obj = {
                    accStatusUseId: formData.dealType,
                    accStatusExtUseId: formData.dealtypeOption,
                    freeText: formData.freeText ? formData.freeText : '',
                };

                //console.log(obj, 'this is obj');
                contractSubTypeListArray.push(obj);
            }
            // console.log(contractSubTypeListArray, 'request data');
            //console.log(formData.dealTypes, 'deal name');
            if (newDealState) {
                const requestData: any = {
                    contractType: formData.dealName,
                    contractSubTypeList: contractSubTypeListArray,
                    step: 2,
                };
                const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                dispatch(createNewDealStageActions.success(data));
                dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
                //console.log(requestData, 'request data');
            }
        }
        dispatch(newDealFormNextStep());
    } catch (e) {
        dispatch(createNewDealStageActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const createNewDealStepThreeThunk: AppThunk<any & { isDirty: boolean }> = formData => {
    return async (dispatch, getState) => {
        try {
            dispatch(createNewDealStageActions.request());
            const newDealState = selectNewDeal(getState());
            const deal = selectUserData(getState());
            let legalUser = deal?.contacts?.find((person: any) => String(person.contactCode) === String(formData.newLegalEntityData));
            let companyDetails = deal?.contacts?.find((person: any) => String(person.contactCode) === String(formData.newCompanyContactData));

            if (newDealState && (legalUser || companyDetails)) {
                const requestData: any = {
                    contractCompany: formData.dealCompany,
                    addressLine1: formData.address1,
                    addressLine2: formData.address2,
                    addressLine3: formData.address3,
                    addressLine4: formData.address4,
                    contractFirst: formData.contractFirst,
                    contractLast: formData.contractLast,
                    konAddId: formData.konAddId,
                    IMAGE: [],
                    contractPostCode: formData.contractPostCode,
                    contractEmail: formData.contractEmail,
                    contractTelephone: formData.contractTelephone,
                    legalEntityId: legalUser?.userId,
                    companyContactId: companyDetails?.userId,
                    contractLegalContact: legalUser?.contactCode,
                    contractContact: companyDetails?.contactCode,
                    step: 3,
                };
                // console.log(requestData, 'requestData -- test');

                if (legalUser && deal) {
                    const creatorId = formData.creatorId;
                    const contactId = legalUser.contactId;
                    const contactCode = legalUser.contactCode;
                    const kontactId = legalUser.kontactId;
                    const creatorCode = legalUser.creatorCode;
                    const kontactCode = deal.contactCode;

                    let data1: any = {
                        FIRST_NAME: formData.contractFirstforUser,
                        LAST_NAME: formData.contractLastforUser,
                        COMPANY_NAME: formData.legalCompany,
                        PHONE: formData.contractTelephoneforUser,
                        PHONE2: legalUser?.phone2,
                        PHONE3: legalUser?.phone3,
                        PHONE4: legalUser?.phone4,
                        EMAIL: formData.contractEmailforUser,
                        DESCRIPTION: legalUser.description,
                        konAddId: formData.konAddIdforUser,
                        addressLine1: formData.address1forUser,
                        addressLine4: formData.address4forUser,
                        addressLine2: formData.address2forUser,
                        addressLine3: formData.address3forUser,
                        postal_code: formData.contractPostCodeforUser,
                        ROLE: typeof legalUser.contactType === 'number' ? legalUser.contactType : '8',
                        IMAGE: [formData.imageUser[0]],
                        CREATOR_ROLE: legalUser.role,
                        CREATOR_FULL_NAME: legalUser.fullName,
                        startDate: legalUser.startDate,
                        endDate: legalUser?.endDate,
                        contactId: legalUser?.contactId,
                        contactCode: legalUser?.contactCode,
                        ipiList: legalUser?.ipiList,
                    };
                    // console.log(data1, 'data1 - test 0');

                    dispatch(createContact({ ...data1, creatorId, contactId, contactCode, kontactId, creatorCode, kontactCode, isUpdate: true }));
                    // console.log({ ...data1, creatorId, contactId, contactCode, kontactId, creatorCode, kontactCode });
                }

                if (companyDetails && deal) {
                    const creatorId = formData.creatorId;
                    const contactId = companyDetails.contactId;
                    const contactCode = companyDetails.contactCode;
                    const kontactId = companyDetails.kontactId;
                    const creatorCode = companyDetails.creatorCode;
                    const kontactCode = deal.contactCode;

                    let data1: any = {
                        FIRST_NAME: formData.contractFirst,
                        COMPANY_NAME: formData.companyName,
                        LAST_NAME: formData.contractLast,
                        PHONE: formData.contractTelephone,
                        PHONE2: companyDetails?.phone2,
                        PHONE3: companyDetails?.phone3,
                        PHONE4: companyDetails?.phone4,
                        EMAIL: formData.contractEmail,
                        DESCRIPTION: companyDetails.description,
                        konAddId: formData.konAddId,
                        addressLine1: formData.address1,
                        addressLine4: formData.address4,
                        addressLine2: formData.address2,
                        addressLine3: formData.address3,
                        postal_code: formData.contractPostCode,
                        ROLE: '11',
                        IMAGE: [formData.imageCompany[0]],
                        CREATOR_ROLE: companyDetails.role,
                        CREATOR_FULL_NAME: companyDetails.fullName,
                        startDate: companyDetails.startDate,
                        endDate: companyDetails?.endDate,
                        contactId: companyDetails?.contactId,
                        contactCode: companyDetails?.contactCode,
                        ipiList: companyDetails?.ipiList,
                    };
                    //console.log(data1, 'data1 - test 1');
                    dispatch(
                        createContact({
                            ...data1,
                            creatorId,
                            contactId,
                            contactCode,
                            kontactId,
                            creatorCode,
                            kontactCode,
                            isUpdate: true,
                        })
                    );
                }

                const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                dispatch(createNewDealStageActions.success(data));
                dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
            } else {
                const requestData: any = {
                    contractCompany: '',
                    contractAdd1: formData.address1,
                    contractAdd2: formData.address2,
                    contractAdd3: formData.address3,
                    contractAdd4: formData.address4,
                    contractFirst: formData.contractFirst,
                    contractLast: formData.contractLast,
                    konAddId: formData.konAddId,
                    IMAGE: [],
                    contractPostCode: formData.contractPostCode,
                    contractEmail: formData.contractEmail,
                    contractTelephone: formData.contractTelephone,
                    legalEntityId: 0,
                    companyContactId: 0,
                    contractLegalContact: 0,
                    step: 3,
                };
                //console.log(requestData, 'requestData -- - test 1');

                const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                dispatch(createNewDealStageActions.success(data));
                if (newDealState) {
                    dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
                }
            }
            //}
            dispatch(newDealFormNextStep());
        } catch (e) {
            dispatch(createNewDealStageActions.failure({ error: e }));
            return errorHandler(e, dispatch);
        }
    };
};

export const createNewDealStepFourThunk: AppThunk<INewDealStepFourFormInputs & { isDirty: boolean }> = formData => {
    return async (dispatch, getState) => {
        try {
            if (formData.isDirty) {
                dispatch(createNewDealStageActions.request());
                const newDealState = selectNewDeal(getState());
                if (newDealState) {
                    const requestData: NewDealStepFourData = {
                        startDate: formData.startDate,
                        endDate: formData.endDate,
                        contractAccounting: formData.terms,
                        step: 4,
                        paymentNotes: formData.paymentNotes,
                    };
                    const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                    dispatch(createNewDealStageActions.success(data));
                    dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
                }
            }
            dispatch(newDealFormNextStep());
        } catch (e) {
            dispatch(createNewDealStageActions.failure({ error: e }));
            return errorHandler(e, dispatch);
        }
    };
};

export const createNewDealStepFiveThunk: AppThunk<any> = formData => {
    return async (dispatch, getState) => {
        try {
            dispatch(createNewDealStageActions.request());
            const newDealState = selectNewDeal(getState());
            if (newDealState) {
                formData.acquisition &&
                    formData.acquisition.length > 0 &&
                    formData.acquisition.forEach((element: any) => {
                        element['contractAcquisitionID'] = element.value;
                        delete element.value;
                        element['contractAcquisitionTypeId'] = element.Id;
                        delete element.Id;
                        element['contractAcquisitionFreeText'] = formData.acquisitionText;
                        delete element.Text;
                    });
                const requestData: any = {
                    keyDates: [
                        {
                            contractNotesID: formData.contractNotesID,
                            entryDate: formData.entryDate,
                            contractType: formData.contractType,
                            contractNotes: formData.contractNotes,
                            contractRefNum: formData.contractRefNum,
                            contractNotesOther: formData.contractNotesOther,
                            contractNotesAmount: formData.contractNotesAmount,
                            contractNotesCurrency: formData.contractNotesCurrency,
                            contractAcquisitionList: formData.acquisition,
                        },
                    ],
                    step: 5,
                };
                //console.log(requestData, '=== reuqest data');

                const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                dispatch(createNewDealStageActions.success(data));
                dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
            }

            // dispatch(newDealFormNextStep());
        } catch (e) {
            dispatch(createNewDealStageActions.failure({ error: e }));
            return errorHandler(e, dispatch);
        }
    };
};

export const createNewDealStepSixThunk: AppThunk<StepSixFormData> = formData => {
    return async (dispatch, getState) => {
        try {
            console.log('formData', formData);
            dispatch(createNewDealStageActions.request());
            const newDealState = selectNewDeal(getState());
            if (newDealState) {
                // const requestData: NewDealStepSixData = {
                //     royaltyRates:
                //         formData.royaltyRates && formData.royaltyRates.length > 0
                //             ? formData.royaltyRates.map(item => ({
                //                   contractRateID: item.contractRateID,
                //                   contractRateRate: item.rate,
                //                   contractRateRegion: item.region === 'CUSTOM' ? item?.customInput : item.region,
                //                   contractRateFormat: item.format,
                //               }))
                //             : [],
                //     recoupables:
                //         formData.recoupables && formData.recoupables.length
                //             ? formData.recoupables.map(item => ({
                //                   contractRecoupID: item.contractRecoupID,
                //                   contractRecoupCode: item.contractRecoupCode,
                //                   contractRecoupRegion: item.region === 'CUSTOM' ? item?.customInput : item.region,
                //                   contractRecoupRate: item.rate,
                //               }))
                //             : [],
                //     step: 6,
                // };
                // const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                // dispatch(createNewDealStageActions.success(data));
                // await DealApi.dealUpdateStatus(newDealState.contractRefNum, 2);
                // // notifySuccess({
                // //     title: 'Success',
                // //     message: `Deal with name "${newDealState.contractTitle}" successfully added`,
                // // });
                // await CreatorApi.getCreatorContacts(newDealState.projectId);
                // await DealApi.getDeals(newDealState.projectId);
                // dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
                // dispatch(resetNewDealForm());
                // dispatch(push(`/creators-list/${newDealState.projectId}/dashboard/deals/table`));
                dispatch(newDealFormNextStep());
            }
        } catch (e) {
            dispatch(createNewDealStageActions.failure({ error: e }));
            return errorHandler(e, dispatch);
        }
    };
};

export const createNewDealStepSixRoyaltyThunk: AppThunk<any> = formData => {
    return async (dispatch, getState) => {
        try {
            console.log('formData', formData);
            dispatch(createNewDealStageActions.request());
            const newDealState = selectNewDeal(getState());
            if (newDealState) {
                const requestData: any = {
                    royaltyRates:
                        formData.royaltyRates && formData.royaltyRates.length > 0
                            ? formData.royaltyRates.map((item: any) => ({
                                  contractRateID: Number(item.contractRateID),
                                  contractRateRate: item.contractRateRate,
                                  contractRateRegion: item.contractRateRate === 'CUSTOM' ? item?.contractRateRegion : item.contractRateRegion,
                                  contractRateFormat: item.contractRateFormat,
                              }))
                            : [],
                    recoupables:
                        formData.recoupables && formData.recoupables.length
                            ? formData.recoupables.map((item: any) => ({
                                  contractRecoupID: Number(item.contractRecoupID),
                                  contractRecoupCode: item.contractRecoupCode,
                                  contractRecoupRegion: item.contractRecoupRegion === 'CUSTOM' ? item?.contractRecoupRegion : item.contractRecoupRegion,
                                  contractRecoupRate: item.contractRecoupRate,
                              }))
                            : [],
                    step: 6,
                };
                const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                dispatch(createNewDealStageActions.success(data));
                await DealApi.dealUpdateStatus(newDealState.contractRefNum, 2);
                await CreatorApi.getCreatorContacts(newDealState.projectId);
                dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
                // dispatch(newDealFormNextStep());
            }
        } catch (e) {
            dispatch(createNewDealStageActions.failure({ error: e }));
            return errorHandler(e, dispatch);
        }
    };
};

export const createNewDealStepSixRoyaltyDeleteThunk: AppThunk<any> = formData => {
    return async (dispatch, getState) => {
        try {
            dispatch(createNewDealStageActions.request());
            const newDealState = selectNewDeal(getState());

            if (newDealState) {
                const requestData: any = {
                    royaltyRates: newDealState.royaltyRates,
                    recoupables: newDealState.recoupables,
                    step: 6,
                };

                if (formData.type === 'royalty') {
                    await axiosInstance.delete('/catalogue/projectCreator/royaltyrates', { params: { contractrateId: Number(formData.id) } });
                    requestData['royaltyRates'] = await newDealState.royaltyRates.filter((item: any) => item.contractRateID !== Number(formData.id));
                }
                if (formData.type === 'recoupable') {
                    await axiosInstance.delete('/catalogue/projectCreator/recoupables', { params: { contractrecoupId: Number(formData.id) } });
                    requestData['recoupables'] = await newDealState.recoupables.filter((item: any) => item.contractRecoupID !== Number(formData.id));
                }

                console.log(requestData, 'request data');

                // await DealApi.dealUpdateStatus(newDealState.contractRefNum, 2);
                const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                dispatch(createNewDealStageActions.success(data));
                await DealApi.dealUpdateStatus(newDealState.contractRefNum, 2);
                await CreatorApi.getCreatorContacts(newDealState.projectId);
                dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
                // dispatch(newDealFormNextStep());
            }
        } catch (e) {
            dispatch(createNewDealStageActions.failure({ error: e }));
            return errorHandler(e, dispatch);
        }
    };
};

export const createNewDealStepSevenThunk: AppThunk<StepSevenFormData> = formData => {
    return async (dispatch, getState) => {
        try {
            dispatch(createNewDealStageActions.request());
            const newDealState = selectNewDeal(getState());
            if (newDealState) {
                const requestData: any = {
                    contractType: formData?.isDealComplete ? 'COMPLETE' : 'INCOMPLETE',
                    signatureDate: formData.signatureDate,
                    step: 7,
                };
                const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                dispatch(createNewDealStageActions.success(data));
                await DealApi.dealUpdateStatus(newDealState.contractRefNum, 2);
                dispatch(resetNewDealForm());
                notifySuccess({ title: 'Success', message: `Deal completed` });

                dispatch(getDealsThunk({ creatorId: newDealState.projectId }));
                // dispatch(push(`/creators-list/${newDealState.projectId}/dashboard/deals/table`));
                //dispatch(push(`/creators-list/${newDealState.projectId}/dashboard/deals/table/${newDealState?.contractRefNum}/details`));

                setTimeout(
                    () => dispatch(push(`/creators-list/${newDealState.projectId}/dashboard/deals/table/${newDealState?.contractRefNum}/details`)),
                    1000
                );
            }
        } catch (e) {
            dispatch(createNewDealStageActions.failure({ error: e }));
            return errorHandler(e, dispatch);
        }
    };
};

export const createRoyalityRecoupleThunk: AppThunk<StepSixFormData> = formData => {
    return async (dispatch, getState) => {
        try {
            dispatch(createNewDealStageActions.request());
            const newDealState = selectNewDeal(getState());
            if (newDealState) {
                const requestData: NewDealStepSixData = {
                    royaltyRates: formData.royaltyRates.map(item => ({
                        contractRateID: item.contractRateID,
                        contractRateRate: item.rate,
                        contractRateRegion: item.region,
                        contractRateFormat: item.format,
                    })),
                    recoupables: formData.recoupables.map(item => ({
                        contractRecoupID: item.contractRecoupID,
                        contractRecoupCode: item.contractRecoupCode,
                        contractRecoupRegion: item.region,
                        contractRecoupRate: item.rate,
                    })),
                    step: 6,
                };
                const { data } = await DealApi.createNewDeal({ ...newDealState, ...requestData });
                dispatch(createNewDealStageActions.success(data));
                dispatch(getDealsThunk({ creatorId: newDealState.projectId }));

                // await DealApi.dealUpdateStatus(newDealState.contractRefNum, 2);
            }
            // dispatch(resetNewDealForm())
            // dispatch(newDealFormNextStep());
        } catch (e) {
            dispatch(createNewDealStageActions.failure({ error: e }));
            return errorHandler(e, dispatch);
        }
    };
};

interface goEditDeal_props {
    assetCode: string;
    dealStep?: any;
}

export const goToEditDealThunk: AppThunk<goEditDeal_props> = p => async (dispatch, getState) => {
    // await dispatch(getDealDetailsThunk(p));
    dispatch(resetNewDealForm());
    const deal = selectDealsResponse(getState()).find(({ assetCode }) => assetCode === p.assetCode);
    if (deal) {
        let deal_step;
        if (p.dealStep !== undefined) {
            deal_step = p.dealStep;
        } else if (Number(deal.step) === 6) {
            deal_step = 1;
        } else {
            deal_step = deal.step;
        }
        dispatch(editNewDealForm({ step: deal_step }));

        const data: NewDealResponseDto = {
            contractAccounting:
                deal.accountingPeriod === 0
                    ? AccountingTerm.NULL
                    : deal.accountingPeriod === 1
                    ? AccountingTerm.MONTHLY
                    : deal.accountingPeriod === 2
                    ? AccountingTerm.QUARTERLY
                    : deal.accountingPeriod === 3
                    ? AccountingTerm.BI_ANNUAL
                    : AccountingTerm.YEARLY,
            contractAdd1: deal.addLine1Contract,
            contractAdd2: deal.addLine2Contract,
            contractAdd3: deal.addLine3Contract,
            contractAdd4: deal.addLine4Contract,
            contractRefNum: deal.assetCode,
            contractCompany: deal.contractCompany,
            startDate: deal.contractStartDate,
            endDate: deal.contractEndDate,
            contractTitle: deal.contractTitle,
            contractType: deal.dealType,
            contractEmail: deal.emailAddressContract,
            projectId: deal.projectId,
            contractGayaaID: deal.contractGayaaId,
            keyDates: deal.keyDates,
            recoupables: deal.recoupables,
            royaltyRates: deal.royaltyRates,
            contractFirst: deal.firstName,
            contractLast: deal.lastName,
            contractPostCode: deal.addressPostCode,
            contractTelephone: deal.telephoneNumContract,
            paymentNotes: deal.paymentNotes,
            contractSubTypeList: deal.contractSubTypeList,
            companyContact: deal.companyContactId,
            legalContact: deal.legalEntityId,
            companyContactId: deal.companyContactId,
            legalEntityId: deal.legalEntityId,
            step: deal_step,
            signatureDate: deal.signatureDate,
            contractContact: deal.contractContact,
            contractLegalContact: deal.contractLegalContact,
        };
        dispatch(createNewDealStageActions.success(data));
        dispatch(push({ pathname: `/creators-list/${deal.projectId}/dashboard/deals/add-deal/${data.contractRefNum}/`, state: { flag: 'edit_deal' } }));
    }
};

export const goToEditSongThunk: AppThunk<{ assetCode: string }> = p => async (dispatch, getState) => {
    // await dispatch(getDealDetailsThunk(p));
    dispatch(resetNewDealForm());

    // console.log(p.assetCode)
    const response = await MusicApi.getMusicDetail(p.assetCode);
    const deal = response.songDetail;
    // console.log(response, '=== all response');
    // console.log(deal, '==== song deal');
    if (deal) {
        //dispatch(editNewDealForm({step:deal.step}));

        // const data_new: NewSongStepOneData = {
        //     gSongEntryID: deal.gSongEntryId,
        //     gProjectId: deal.projectId,
        //     gSongName: deal.songName || null,
        //     isPubEligible: deal.isPubEligible,
        //     isRecEligible: deal.isRecEligible,
        //     isNBREligible: deal.isNBREligible,
        // };
        const stepOneData = { gSongName: deal.songName, gSongEntryID: deal.gSongEntryId, gProjectId: deal.projectId };

        const { data } = await MusicApi.createNewSong(stepOneData);

        console.log(data, '=== data after creating');

        dispatch(createNewSongStageActions.success(data));
        dispatch(push({ pathname: `/creators-list/${deal.projectId}/dashboard/songs/add-song` }));
    }
};

export const getSongEditDetailThunk: AppThunk<{ assetCode: string; gotoStep: any }> = p => async (dispatch, getState) => {
    dispatch(resetNewSongForm());
    dispatch(createNewSongStageActions.request());
    const response = await MusicApi.getMusicDetail(p.assetCode);
    const deal = response.songDetail;

    if (deal) {
        const stepOneData = {
            gSongName: deal.songName,
            gSongEntryID: deal.gSongEntryId,
            gProjectId: deal.projectId,
            gSongRef: deal.assetCode,
            isNBREligible: deal.isNBREligible,
            isPubEligible: deal.isPubEligible,
            isRecEligible: deal.isRecEligible,
            isOtherEligible: deal.isOtherEligible,
            isWriterShareEligible: deal.isWriterShareEligible,
        };

        const { data } = await MusicApi.createNewSong(stepOneData);
        const data1 = await MusicApi.getSongTag(data.gSongRef, data.gProjectId);
        data.songsDataTags = data1.data;

        switch (p.gotoStep) {
            case 6:
                const data1 = await MusicApi.getSongTag(data.gSongRef, data.gProjectId);
                data.songsDataTags = data1.data;
                await dispatch(createNewSongStageActions.success(data));
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                break;
            case 2:
                await dispatch(createNewSongStageActions.success(data));
                dispatch(newSongFormNextStep());
                break;
            case 5:
                await dispatch(createNewSongStageActions.success(data));
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                break;
            case 3:
                await dispatch(createNewSongStageActions.success(data));
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                break;
            case 4:
                await dispatch(createNewSongStageActions.success(data));
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());
                dispatch(newSongFormNextStep());

                break;
            default:
                await dispatch(createNewSongStageActions.success(data));

                break;
        }
    }
};

export const goToEditContactThunk: AppThunk<{ contactId: string; projectId: number }> = p => async (dispatch, getState) => {
    const deal = selectUserData(getState());
    const contact = deal?.contacts.find(({ contactId }) => contactId === p.contactId);
    if (contact) {
        dispatch(createContactActions.success(contact));
    }
};

export const goToEditCreatorThunk: AppThunk<{ kontactId: number; projectId: number; creatorCode: string }> = p => async (dispatch, getState) => {
    const deal = selectUserData(getState());
    const contact = deal;

    if (contact) {
        dispatch(createContactActions.success(contact));
    }
};

export const createNewSongStepOneThunk: AppThunk<INewSongStepOneFormInputs & { creatorId: number; isDirty: boolean }> = formData => async (
    dispatch,
    getState
) => {
    try {
        // if (formData.isDirty) {
        dispatch(createNewSongStageActions.request());
        const newSongState = selectNewSong(getState());
        //console.log(newSongState, "==== this this song detail in action thunk")

        const stepOneData: NewSongStepOneData = {
            gSongName: formData.songName,
            gProjectId: formData.creatorId,
            isPubEligible: Number(formData.isPubEligible),
            isRecEligible: Number(formData.isRecEligible),
            isNBREligible: Number(formData.isNBREligible),
            isOtherEligible: Number(formData.isOtherEligible),
            isWriterShareEligible: Number(formData.isWriterShareEligible),
        };
        const requestData = newSongState?.gSongRef
            ? {
                  gSongEntryID: newSongState?.gSongEntryID,
                  gSongRef: newSongState?.gSongRef,
                  ...stepOneData,
              }
            : stepOneData;
        console.log(requestData, '== step 1 data');
        const { data } = await MusicApi.createNewSong(requestData);
        // console.log(data, '=== creating song');
        dispatch(createNewSongStageActions.success(data));
        dispatch(getMusicsThunk({ creatorId: formData.creatorId }));

        // }
        dispatch(newSongFormNextStep());
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e.response.data.ExceptionMessage, dispatch);
    }
};

export const createNewSongStepTwoThunk: AppThunk<INewSongStepTwoFormInputs & { isDirty: boolean }> = formData => async (dispatch, getState) => {
    try {
        // console.log(formData, 'formData');
        if (formData.isDirty) {
            dispatch(createNewSongStageActions.request());
            const newSongState = selectNewSong(getState());
            if (newSongState) {
                const stepTwoData = {
                    ...newSongState,
                    gMyWriterName: formData.writerName,
                    gPublisherName: formData.publisherName,
                    gSongCode2: formData.CAECode,
                    gWriterShare: formData.writingShare,
                    gPublishingShare: formData.publishingshare,
                };
                const { data } = await MusicApi.createNewSong(stepTwoData);
                dispatch(createNewSongStageActions.success(data));
            }
        }
        dispatch(newSongFormNextStep());
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler('Song Name already exists. Please create a new one.', dispatch);
    }
};

export const createNewSongStepThreeThunk: AppThunk<INewSongStepThreeFormInputs & { isDirty: boolean }> = formData => async (dispatch, getState) => {
    try {
        // dispatch(createNewSongStageActions.request());
        //
        // const newSongState = selectNewSong(getState());
        //
        // let date = new Date(formData.releaseDate);
        //
        // if (newSongState) {
        //     const stepThreeData = {
        //         ...newSongState,
        //         gSongMainArtist: formData.mainArtist,
        //         gSongFeatArtist1: formData.featArtist1,
        //         gSongFeatArtist2: formData.featArtist2,
        //         gSongFeatArtist3: formData.featArtist3,
        //         gSongProducer1: formData.producer1,
        //         gSongProducer2: formData.producer2,
        //         gSongProducer3: formData.producer3,
        //         gSongISRC: formData.gSongISRC,
        //         gSongUPC: formData.gSongUPC,
        //         gSongReleaseDate: date,
        //         gSongReleaseYear: formData.releaseYear,
        //     };
        //     const { data } = await MusicApi.createNewSong(stepThreeData);
        //     const data1 = await MusicApi.getSongTag(data.gSongRef, data.gProjectId);
        //     data.songsDataTags = data1.data;
        //     dispatch(createNewSongStageActions.success(data));
        // }
        dispatch(newSongFormNextStep());
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const createNewSongStepFourThunk: AppThunk<INewSongStepFourFormInputs> = formData => async (dispatch, getState) => {
    try {
        dispatch(createNewSongStageActions.request());
        const newSongState = selectNewSong(getState());
        if (newSongState && formData.songProjectTrack) {
            const stepFourData = {
                ...newSongState,
                gSongFirstDeal: formData.firstDeal,
                isSongReleased: Number(formData.isSongReleased),
                songProjectTrack: formData.songProjectTrack.map(t => ({
                    ...(newSongState.songProjectTrack.find(oldT => oldT.isrc === t.isrc) || {}),
                    ...t,
                    isKeyTrack: t.isKeyTrack ? 1 : 0,
                    releaseDate:
                        moment.utc(t.releaseDate) &&
                        t.releaseDate !== '' &&
                        t.releaseDate !== 'null' &&
                        t.releaseDate !== null &&
                        t.releaseDate !== 'Invalid date'
                            ? moment.utc(t.releaseDate).format('YYYY-MM-DD')
                            : null,
                })),
            };
            let { data } = await MusicApi.createNewSong(stepFourData);
            const data1 = await MusicApi.getSongTag(data.gSongRef, data.gProjectId);
            data.songsDataTags = data1.data;

            dispatch(createNewSongStageActions.success(data));
        }
        dispatch(newSongFormNextStep());
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const createNewSongStepFiveThunk: AppThunk<SongProjectTrack[]> = formData => async (dispatch, getState) => {
    try {
        dispatch(createNewSongStageActions.request());
        const newSongState = selectNewSong(getState());

        // let elenm: any = newSongState?.gSongNotesEntry
        //     .filter(item => item.gSongNotesEntryID !== formData.NotesID)
        //     .map(item => ({
        //         gSongNotesEntryID: item.gSongNotesEntryID,
        //         gSongNotes: item.gSongNotes,
        //         gSongNoteType: item.gSongNoteType,
        //         gSongNoteEntryDate: item.gSongNoteEntryDate,
        //         gSongNotesOther: item.gSongNotesOther,
        //     }));
        // let date = new Date(formData.entryDate);
        // // if (newSongState) {
        // const stepFiveData = {
        //     ...newSongState,
        //     gSongNotesEntry: [
        //         ...elenm,
        //         {
        //             gSongNotesEntryID: formData.NotesID,
        //             gSongNotes: formData.keyNote,
        //             gSongNoteType: formData.keyDateType,
        //             gSongNoteEntryDate: date,
        //             gSongNotesOther: formData.keyNoteOther,
        //         },
        //     ],
        // };
        const stepFiveData = { ...newSongState, songProjectTrack: formData || newSongState?.songProjectTrack || [] }

        const { data } = await MusicApi.createNewSong(stepFiveData);
        if (data) {
            await axiosInstance.get(`/Catalogue/projectcreator/songtagslist?gsongRef=${data.gSongRef}`).then(async res => {
                if (res && res.data.length > 0) data.gSongAssets = await res.data.data;
                else data.gSongAssets = await [];
                await dispatch(createNewSongStageActions.success(data));
            });
        }
        // }
        // dispatch(newSongFormNextStep());
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const createNewSongStepSixThunk: AppThunk<songsDataTags> = formData => async (dispatch, getState) => {
    try {
        dispatch(createNewSongStageActions.request());
        const newSongState = selectNewSong(getState());

        const stepSixData = {
            id: formData.songTagId,
            projectId: newSongState?.gProjectId,
            gSongRef: newSongState?.gSongRef,
            gSongFileName: formData.gSongFileName,
            gSongFilePath: formData.gSongFilePath,
            gSongSoundTags: formData.gSongSoundTags,
            gSongArtworkTags: formData.gSongArtworkTags,
            assetVersion: formData.assetVersion,
        };
        const { data } = await axiosInstance.post('/catalogue/projectCreator/songtags/save', stepSixData);
        return data;
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const isrcSongTagLink: AppThunk<{ isrc: string; songTagId: number }> = formData => async (dispatch, getState) => {
    try {
        const newSongState = selectNewSong(getState());

        const link = {
            projectId: newSongState?.gProjectId,
            gSongRef: newSongState?.gSongRef,
            ISRC: formData.isrc,
            SongTagId: formData.songTagId,
        };
        const { data } = await axiosInstance.post('/catalogue/projectCreator/isrcsongtaglink/save', link);
        return data;
    } catch (e) {
        return errorHandler(e, dispatch);
    }
};

export const createContact: AppThunk<
    NewUser & { creatorId: number; contactId: number; contactCode: string; kontactId: number; creatorCode: string; kontactCode: any; isUpdate?: boolean }
> = newContactData => async (dispatch, getState) => {
    const userData = getContactTypeList(getState()).find(item => item.name === newContactData.ROLE || item.code === newContactData.ROLE);

    let role = userData?.code !== undefined ? userData?.code : newContactData.ROLE;

    console.log(newContactData);
    const data_append = JSON.stringify({
        kontactId: newContactData.contactId,
        companyName: newContactData.COMPANY_NAME,
        kontactCode: newContactData.contactCode,
        firstName: newContactData.FIRST_NAME,
        lastName: newContactData.LAST_NAME,
        emailAdd1: newContactData.EMAIL,
        description: newContactData.DESCRIPTION,
        kontactsAddresses: {
            konAddId: newContactData?.konAddId || 0,
            telephone: newContactData.PHONE,
            telephone2: newContactData.PHONE2,
            telephone3: newContactData.PHONE3,
            telephone4: newContactData.PHONE4,
            telephoneType: newContactData.PHONEType ? newContactData.PHONEType.Id : 1,
            telephone2Type: newContactData.PHONE2Type ? newContactData.PHONE2Type.Id : 1,
            telephone3Type: newContactData.PHONE3Type ? newContactData.PHONE3Type.Id : 1,
            telephone4Type: newContactData.PHONE4Type ? newContactData.PHONE4Type.Id : 1,
            addressLine1: newContactData.addressLine1,
            addressLine2: newContactData.addressLine2,
            addressLine3: newContactData.addressLine3,
            addressLine4: newContactData.addressLine4,
            addressPostCode: newContactData.postal_code,
        },
    });
    console.log(data_append, 'data_append');
    const formData = new FormData();
    formData.append('projectId', newContactData.creatorId);
    formData.append('data', data_append);
    formData.append('contactStart', moment.utc(newContactData.startDate).format('YYYY-MM-DD'));
    formData.append('contactEnd', moment.utc(newContactData.endDate).format('YYYY-MM-DD'));
    if (newContactData.IMAGE?.length > 0) {
        formData.append('file', newContactData.IMAGE[0]);
    }
    formData.append('contactType', role);

    try {
        const data = await ContractApi.createNewContact(formData);

        const result = {
            ...fakeUserData,
            fullname: data.kontactName,
        };

        await dispatch(createContactActions.success(result));
        await dispatch(getContactsThunk({ creatorId: newContactData.creatorId }));

        if (newContactData.isUpdate === undefined) {
            await notifySuccess({ title: 'Success', message: `Contact successfully added` });
        }
        console.log(data, 'evgen data');
        return data;
    } catch (e) {
        dispatch(createContactActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getContactsThunk: AppThunk<{ creatorId: number }> = p => async dispatch => {
    dispatch(getContactsActions.request(p));
    try {
        const data = await CreatorApi.getCreatorContacts(p.creatorId);
        await dispatch(getAKAsListings({ creatorId: p.creatorId }));

        const result = {
            ...fakeUserData,
            name: data.projectName,
            fullName: data.projectName,
            firstName: data.firstName,
            lastName: data.lastName,
            kontactId: data.kontactId,
            konAddId: data.creatorKonAddId,
            creatorCode: data.creatorCode,
            address: getAddressString([data.creatorAddressLine1]),
            addressLine1: getAddressString([data.creatorAddressLine1]),
            addressLine2: getAddressString([data.creatorAddressLine2]),
            addressLine3: getAddressString([data.creatorAddressLine3]),
            addressLine4: getAddressString([data.creatorAddressLine4]),
            cityName: getAddressString([data.creatorAddressLine3]),
            street: getAddressString([data.creatorAddressLine2]),
            country: getAddressString([data.creatorAddressLine4]),
            description: data.description,
            zipCode: data.creatorPostCode,
            phone: data.creatorTelephone,
            phone2: data.creatorTelephone2,
            phone3: data.creatorTelephone3,
            phone4: data.creatorTelephone4,
            phoneType: data.creatorTelephoneType,
            phoneType2: data.creatorTelephone2Type,
            phoneType3: data.creatorTelephone3Type,
            phoneType4: data.creatorTelephone4Type,
            email: data.creatorEmail,
            role: data.licenseProjectType,
            image: process.env.REACT_APP_ASSET + data.creatorImage,
            contactCode: data.creatorCode,
            contactId: data.kontactId,
            creatorCompanyName: data.creatorCompanyName,
            ipiList: data.ipiList.map(contact => ({
                additionalIpNumber: contact.additionalIpNumber,
                affiliation: contact.affiliation,
                affiliationCode: contact.affiliationCode,
                createdBy: contact.createdBy,
                iPNumber: contact.iPNumber,
                knownAs: contact.knownAs,
                kontactCode: contact.kontactCode,
                kontacts_IPI_Id: contact.kontacts_IPI_Id,
                modifiedBy: contact.modifiedBy,
                modifiedDate: contact.modifiedDate,
            })),
            contacts: data.contacts.map(contact => ({
                ...fakeContactData,
                companyName: contact.companyName,

                userId: contact.projectContactId,
                name: contact.contactName || '...',
                address: getAddressString([contact.contactAddressLine1]),
                route: contact.contactAddressLine2,
                countryName: contact.contactAddressLine4,
                cityName: contact.contactAddressLine3,
                zipCode: contact.contactPostCode,
                phone: contact.contactTelephone ? `${contact.contactTelephone}` : '',
                phone2: contact.contactTelephone2 ? `${contact.contactTelephone2}` : '',
                phone3: contact.contactTelephone3 ? `${contact.contactTelephone3}` : '',
                phone4: contact.contactTelephone4 ? `${contact.contactTelephone4}` : '',
                konAddId: contact.konAddId,
                contactType: contact.contactType,
                contactTypeDesc: contact.contactTypeDesc,
                contactStatus: contact.contactStatus,
                email: contact.addEmail,
                image: process.env.REACT_APP_ASSET + contact.kontactImage,
                contactCode: contact.kontactCode,
                contactId: contact.kontactId,
                firstName: contact.firstName,
                lastName: contact.lastName,
                startDate: contact.contactStart,
                endDate: contact.contactEnd,
                description: contact.description,
                addressLine1: contact.contactAddressLine1,
                addressLine2: contact.contactAddressLine2,
                addressLine3: contact.contactAddressLine3,
                addressLine4: contact.contactAddressLine4,
                projectContactId: contact.projectContactId,
                ipiList: contact.ipiList.map(contact => ({
                    additionalIpNumber: contact.additionalIpNumber,
                    affiliation: contact.affiliation,
                    affiliationCode: contact.affiliationCode,
                    createdBy: contact.createdBy,
                    iPNumber: contact.iPNumber,
                    knownAs: contact.knownAs,
                    kontactCode: contact.kontactCode,
                    kontacts_IPI_Id: contact.kontacts_IPI_Id,
                    modifiedBy: contact.modifiedBy,
                    modifiedDate: contact.modifiedDate,
                })),
            })),
            dealContacts: data.dealContacts || [],
        };

        console.log(result, '=== getContactsThunk result');
        dispatch(getContactsActions.success(result));
        return result;
    } catch (e) {
        dispatch(getContactsActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealSongsSummaryThunk: AppThunk<{ creatorId: number; assetCode: string }> = p => async (dispatch, getState) => {
    dispatch(getDealSongsSummaryActions.request(p));
    try {
        const data = await DealApi.getDealSongSummary(p.creatorId, p.assetCode);
        dispatch(getDealSongsSummaryActions.success({ songs: data }));
        // console.log(data, "=== songs from specific deal")
        return data;
    } catch (e) {
        dispatch(getDealSongsSummaryActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealSubDealsSummaryThunk: AppThunk<{ creatorId: number; assetCode: string }> = p => async dispatch => {
    dispatch(getDealSubDealsSummaryActions.request(p));
    try {
        const data = await DealApi.getDealSubDealsSummary(p.creatorId, p.assetCode);
        dispatch(getDealSubDealsSummaryActions.success({ dealSubDeals: data }));
        return data;
    } catch (e) {
        dispatch(getDealSubDealsSummaryActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealDocumentsThunk: AppThunk<{ assetCode: string }> = p => async dispatch => {
    dispatch(getDealDocumentsActions.request(p));
    try {
        const data = await DealApi.getDealDocuments(p.assetCode);
        dispatch(getDealDocumentsActions.success({ dealDocuments: data }));
        return data;
    } catch (e) {
        dispatch(getDealDocumentsActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealDocumentTypesThunk: AppThunk = p => async dispatch => {
    dispatch(getDealDocumentTypesActions.request(p));
    try {
        const data = await DealApi.getDealDocumentTypes();
        dispatch(getDealDocumentTypesActions.success({ dealDocumentTypes: data }));
        return data;
    } catch (e) {
        dispatch(getDealDocumentTypesActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const searchDealFilterAction: AppThunk<{ searchValue: string }> = p => async (dispatch, getState) => {
    dispatch(getSearchDealFilterActions.request({ searchValue: '' }));
    try {
        dispatch(getSearchDealFilterActions.success({ searchDealFilter: p.searchValue }));
        console.log(p, '=== songs from specific deal');
        return p.searchValue;
    } catch (e) {
        dispatch(getSearchDealFilterActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealsThunk: AppThunk<{ creatorId: number }> = p => async (dispatch, getState) => {
    dispatch(getDealsActions.request(p));
    try {
        const data = await DealApi.getDeals(p.creatorId);
        const result = data.map(deal => ({
            ...fakeDeal,
            keyDates2: deal.keyDates,
            assetCode: deal.assetCode,
            paymentNotes: deal.paymentNotes,
            company: deal.contractCompany || '',
            contactDisplayContract: deal.firstName + ' ' + deal.lastName || '',
            contractStartDate: deal.contractStartDate,
            contractEndDate: deal.contractEndDate,
            title: deal.contractTitle,
            dealType: deal.dealType || '',
            contractType: deal.contractType || '',
            incomeType: deal.incomeType || '',
            incomePeriod:
                // (deal.contractStartDate && deal.contractEndDate)
                //     ?
                {
                    start: deal.contractStartDate,
                    end: deal.contractEndDate,
                },
            // : null
            address: `${deal.addLine1Contract} ${deal.addLine2Contract} ${deal.addLine3Contract} ${deal.addLine4Contract}`,
            contractBalance: deal.datesUnknown ? null : deal.contractBalance,
            statementDate: deal.datesUnknown ? null : moment(deal.statementDate.toString(), 'YYYYMMDD').format(GLOBAL_DISPLAY_FORMAT),
            terms: {
                condition: deal.contractTerm || '',
            },
            contractDate: deal.contractDate,
            image: process.env.REACT_APP_ASSET + deal.contactImage || '',
            addLine1Contract: deal.addLine1Contract || '',
            addLine2Contract: deal.addLine2Contract || '',
            addLine3Contract: deal.addLine3Contract || '',
            addLine4Contract: deal.addLine4Contract || '',
            emailAddressContract: deal.emailAddressContract,
            legalContact: deal.legalEntityId,
            companyContact: deal.companyContactId,
            signatureDate: deal.signatureDate,
            companyContactCode: deal.companyContactCode,
            contacts: deal.contacts || [],
        }));

        dispatch(getDealsActions.success({ deals: result, dealsResponse: data }));
        return result;
    } catch (e) {
        dispatch(getDealsActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealSummaryThunk: AppThunk<{ creatorId: number; songRef: string }> = p => async (dispatch, getState) => {
    dispatch(getDealSummaryActions.request(p));
    try {
        const data = await DealApi.getDealSummaryList(p.creatorId, p.songRef);

        dispatch(getDealSummaryActions.success({ deals: data }));
        return data;
    } catch (e) {
        dispatch(getDealSummaryActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealDetailsThunk: AppThunk<{ assetCode: string; projectId: any }> = p => async (dispatch, getState) => {
    dispatch(getDealDetailsActions.request(p));
    try {
        const [data, { data: dealSubTypeList }] = await Promise.all([DealApi.getDealDetails(p.assetCode, p.projectId), DealApi.getDealSubTypeList()]);

        const deals = selectDeals(getState());
        const deal = deals.find(item => item.assetCode === p.assetCode);
        if (deal) {
            const keyDates: { title: string; dates: string[] }[] = [];
            const paymentDates: { title: string; dates: string[] }[] = [];
            const advancesDates: { title: string; dates: string[] }[] = data.advancesDates.map(item => ({
                title: item.advContractNotes,
                dates: [item.advActionDate],
            }));
            const paymentDateData = data.paymentDates[0];
            if (paymentDateData) {
                paymentDates.push({ title: paymentDateData.payContractNotes, dates: [paymentDateData.payStartDate] });
                const futurePayments: { title: string; dates: string[] } = { title: 'Future Payments', dates: [] };
                for (const [key, value] of Object.entries(paymentDateData)) {
                    if (key.match(/^payDate\d/)) {
                        futurePayments.dates.push(value as string);
                    }
                }
                paymentDates.push(futurePayments);
            }
            for (const keyDate of data.keyDates) {
                const title = keyDate.retContractNotes.split(' - ')[0];
                const keyIndex = keyDates.findIndex(item => item.title === title);
                if (keyIndex > -1) {
                    keyDates[keyIndex].dates.push(keyDate.retActionDate);
                } else {
                    keyDates.push({ title, dates: [keyDate.retActionDate] });
                }
            }
            const newDeal: Deal = {
                ...deal,
                paymentNotes: data.paymentNotes,
                contactDisplayContract: deal.contactDisplayContract || '',
                notes: data.notes.map(item => item.contractNotes),
                royaltyRates: orderBy(
                    data.royaltyRates.map((item: any) => ({
                        title: item.contractRateFormat,
                        percent: item.contractRateRate,
                        region: item.contractRateRegion,
                    })),
                    ['percent'],
                    ['desc']
                ),
                recoupableItems: orderBy(
                    data.recoupables.map((item: any) => ({
                        title: item.contractRecoupCode,
                        percent: item.contractRecoupRate,
                        region: item.contractRecoupRegion,
                    })),
                    ['percent'],
                    ['desc']
                ),
                keyDates,
                paymentDates,
                advancesDates,
                description: data.contractDescript,
                contractSubTypeList: data.contractSubTypeList,
            };
            const newDeals = [...deals];
            const newDealResponses = [...selectDealsResponse(getState())];
            const updatedDealIndex = newDeals.findIndex(item => item.assetCode === newDeal.assetCode);
            if (updatedDealIndex >= 0) {
                newDeals[updatedDealIndex] = newDeal;
                newDealResponses[updatedDealIndex].details = data;
            }
            dispatch(getDealDetailsActions.success({ deals: newDeals, dealsResponse: newDealResponses, dealSubTypeList }));
            return newDeal;
        }
        throw new Error('Deal not found');
    } catch (e) {
        dispatch(getDealDetailsActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getMusicsThunk: AppThunk<{ creatorId: number }> = p => async (dispatch, getState) => {
    dispatch(getMusicsActions.request(p));
    try {
        const data = await MusicApi.getMusics(p.creatorId);

        dispatch(getMusicsActions.success(data));
        return data;
    } catch (e) {
        dispatch(getMusicsActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

// DealSOngSUmmarylist
export const getMusicsDealSummaryThunk: AppThunk<{ creatorId: number; assetCode: string }> = p => async (dispatch, getState) => {
    dispatch(getSongSummaryDealActions.request(p));
    try {
        const data = await MusicApi.getSongSummaryList(p.creatorId, p.assetCode);
        // console.log(data, 'asdasdasd');
        dispatch(getSongSummaryDealActions.success(data));
        return data;
    } catch (e) {
        dispatch(getSongSummaryDealActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

// get songs deal summary => Start
export const getSongDealsSummaryThunk: AppThunk<{ creatorId: number; songref: number }> = p => async (dispatch, getState) => {
    dispatch(getSongDealsSummaryActions.request(p));
    try {
        const data = await MusicApi.getSongDealsSummary(p.creatorId, p.songref);
        // console.log(data);
        return data;
    } catch (e) {
        // console.log(e);
    }
};

// get songs deal summary => END

export const getContractsThunk: AppThunk<{ creatorId: number }> = p => async (dispatch, getState) => {
    dispatch(getContractsActions.request(p));
    try {
        const data = await ContractApi.getContracts(p.creatorId);

        dispatch(getContractsActions.success(data));
        return data;
    } catch (e) {
        dispatch(getContractsActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealTypes: AppThunk = () => async (dispatch, getState) => {
    try {
        dispatch(getDealTypesList.request());
        const data = await DealApi.getDealTypeList();
        dispatch(getDealTypesList.success(orderBy(data, [({ name }) => (name.toLowerCase() === 'other' ? 1 : 0), 'name'], ['asc'])));
    } catch (e) {
        dispatch(getDealTypesList.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getContactTypes: AppThunk = () => async (dispatch, getState) => {
    try {
        dispatch(getContactTypesList.request());
        const data = await ContractApi.getContractTypeList();

        dispatch(getContactTypesList.success(data));
    } catch (e) {
        dispatch(getContactTypesList.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealFormats: AppThunk = () => async (dispatch, getState) => {
    try {
        dispatch(getDealFormatsList.request());
        const data = await DealApi.getDealFormatList();
        dispatch(getDealFormatsList.success(data));
    } catch (e) {
        dispatch(getDealFormatsList.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealCodes: AppThunk = () => async (dispatch, getState) => {
    try {
        dispatch(getDealCodesList.request());
        const data = await DealApi.getDealCodeList();
        dispatch(getDealCodesList.success(data));
    } catch (e) {
        dispatch(getDealCodesList.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getDealRegions: AppThunk = () => async (dispatch, getState) => {
    try {
        dispatch(getDealRegionsList.request());
        const data = await DealApi.getDealRegionList();
        dispatch(getDealRegionsList.success(data));
    } catch (e) {
        dispatch(getDealRegionsList.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const setDealFilterDispatch: AppThunk = () => async (dispatch, getState) => {
    const deals = selectDeals(getState());
    console.log(deals, '==== this is deals');
};

export const deleteISRC: AppThunk<{ isrc: string; keyDate: number | undefined; songref: string | undefined }> = p => async dispatch => {
    await axiosInstance.delete(`/catalogue/projectCreator/songprojecttrack?projectid=${p.keyDate}&songref=${p.songref}&isrc=${p.isrc}`);
    dispatch(createNewSongStageActions.request());
};

export const deleteAssets: AppThunk<INewSongStepSixFormInputs> = assetId => async (dispatch, getState) => {
    try {
        dispatch(createNewSongStageActions.request());
        const { data } = await axiosInstance.delete(`catalogue/projectCreator/songtags/delete/${assetId}`);
        return data;
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getUserProfile: AppThunk = () => async (dispatch, getState) => {
    try {
        dispatch(getUserProfileTypes.request());
        const data = await ProfileApi.getUserProfile();
        dispatch(getUserProfileTypes.success(data));
    } catch (e) {
        dispatch(getUserProfileTypes.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const updateDefaultThunk: AppThunk<UserProfile> = formData => async (dispatch, getState) => {
    try {
        dispatch(updateDefaultActions.request());
        const userProfileData = getUserProfileData(getState());
        const data = await ProfileApi.updateProfile({
            ...userProfileData,
            ...formData,
        });
        dispatch(updateDefaultActions.success(data));
    } catch (e) {
        dispatch(updateDefaultActions.failure({ error: e }));
        return errorHandler(e.response.data.ExceptionMessage, dispatch);
    }
};

export const createNewQuickSongEntryUpdateThunk: AppThunk<INewQuickSongForm & { creatorId: number }> = formData => async (dispatch, getState) => {
    try {
        formData.song.map(async (item) => {
            dispatch(createNewSongStageActions.request());
            const newSongState = selectNewSong(getState());

            const stepOneData: NewQuickSongEntryData = {
                gSongEntryID: item.entryID,
                gSongName: item.songName,
                gProjectId: formData.creatorId,
                gSongMainArtist: item.artist,
                gMyWriterName: item.writerName,
                gWriterShare: Number(item.writerShare),
                gPublisherName: item.pubName,
                gPublishingShare: Number(item.pubShare),
                gSongReleaseDate:
                    moment.utc(item.releaseDate) &&
                    item.releaseDate !== '' &&
                    item.releaseDate !== 'null' &&
                    item.releaseDate !== null &&
                    item.releaseDate !== 'Invalid date'
                        ? moment.utc().format('YYYY-MM-DD')
                        : null,
                gSongReleaseYear: item.releaseYear,
                gSongUPC: item.UPC,
                gSongISRC: item.ISRC,
                gSongRef: item.songRef,
            };

            console.log(stepOneData);
            const { data } = await MusicApi.createNewSong({ ...newSongState, ...stepOneData });
            dispatch(createNewSongStageActions.success(data));
        });
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e.response.data.ExceptionMessage, dispatch);
    }
};

export const createNewQuickSongEntryThunk: AppThunk<INewQuickSongFormInputs & { creatorId: number }> = formData => async (dispatch, getState) => {
    try {
        dispatch(createNewSongStageActions.request());
        const userSongState = getUserProfileData(getState());

        const stepOneData: NewQuickSongEntryData = {
            gSongName: formData.songName,
            gSongEntryID: null,
            gProjectId: formData.creatorId,
            gSongMainArtist: userSongState?.defaultArtistName || '',
            gMyWriterName: userSongState?.defaultWriterName || '',
            gWriterShare: 0,
            gPublisherName: userSongState?.defaultPublisherName || '',
            gPublishingShare: 0,
            gSongReleaseDate: '',
            gSongReleaseYear: '',
            gSongUPC: '',
            gSongISRC: '',
        };

        const { data } = await MusicApi.createNewSong(stepOneData);
        dispatch(createNewSongStageActions.success(data));
        return data;
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e.response.data.ExceptionMessage, dispatch);
    }
};

export const getSongListings: AppThunk<any> = title => async (dispatch, getState) => {
    try {
        dispatch(getSongListingsList.request());
        const data = await MusicApi.getSongListingList(title);
        dispatch(getSongListingsList.success(data));
    } catch (e) {
        dispatch(getSongListingsList.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getSongTagsAssets: AppThunk = () => async (dispatch, getState) => {
    try {
        dispatch(createNewSongStageActions.request());
        let newSongState = selectNewSong(getState());
        if (newSongState) {
            const data1 = await MusicApi.getSongTag(newSongState.gSongRef, newSongState.gProjectId);
            newSongState.songsDataTags = data1.data;
            console.log(newSongState);
            dispatch(createNewSongStageActions.success(newSongState));
        }
    } catch (e) {
        dispatch(createNewSongStageActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getTagListings: AppThunk = () => async (dispatch, getState) => {
    try {
        dispatch(getSoundListingsList.request());
        dispatch(getArtworkListingsList.request());
        const data = await MusicApi.getTagListingList('ARTWORK');
        const data1 = await MusicApi.getTagListingList('SOUND');
        dispatch(getSoundListingsList.success(data1));
        dispatch(getArtworkListingsList.success(data));
    } catch (e) {
        dispatch(getSoundListingsList.failure({ error: e }));
        dispatch(getArtworkListingsList.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const updateIPIListListings: AppThunk<any & { creatorId: number }> = formData => async (dispatch, getState) => {
    try {
        (await formData.ipiList) &&
            (await formData.ipiList.length) > 0 &&
            (await formData.ipiList.map(async (item: any) => {
                let obj = {
                    kontacts_IPI_Id: item.kontacts_IPI_Id,
                    iPNumber: item.iPNumber,
                    affiliation: item.affiliation,
                    kontactCode: item.kontactCode,
                };
                if (!item.affiliation && item.kontacts_IPI_Id) {
                    await axiosInstance.delete(`/Contract/kontacts_IPI/delete/${item.kontacts_IPI_Id}`);
                } else {
                    item.affiliation && (await axiosInstance.post('Contract/kontacts_IPI/save', obj));
                }
                return item;
            }));
    } catch (e) {
        dispatch(getContactsActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const getAKAsListings: AppThunk<{ creatorId: number }> = formData => async (dispatch, getState) => {
    try {
        dispatch(getAKAsListingsList.request());
        const data = await CreatorApi.getCreatorAKAs(formData.creatorId);
        dispatch(getAKAsListingsList.success(data));
    } catch (e) {
        dispatch(getAKAsListingsList.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const updateAKAsListings: AppThunk<any & { creatorId: number }> = formData => async (dispatch, getState) => {
    try {
        (await formData.AKAsList) &&
            (await formData.AKAsList.length) > 0 &&
            (await formData.AKAsList.map(async (item: any) => {
                let obj = {
                    kontactAKAID: item.kontactAKAID,
                    projectId: formData.creatorId,
                    kontactCode: item.kontactCode,
                    aka: item.aka,
                };
                console.log(obj);
                await axiosInstance.post('/catalogue/projectcontact/aka/save', obj).then(res => console.log(res,'res AKAs'));
                return item;
            }));
        await dispatch(getAKAsListings({ creatorId: formData.creatorId }));
    } catch (e) {
        dispatch(getContactsActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};
